import useAuth from '@hooks/useAuth';
import { useSettings } from '@hooks/useSettings';
import Button from '@skapa/Button';
import Hyperlink from '@skapa/HyperLink';
import Text from '@skapa/Text';
import { setLocationHref } from '@utils/window';
import useTranslations from 'context/Translations';
import React from 'react';
import styles from './CreateListBlock.module.scss';

type CreateListBlockProps = {
    loading: boolean;
    onCreateList: () => void;
    disabled: boolean;
};

const CreateListBlock: React.FC<CreateListBlockProps> = ({
    loading,
    disabled,
    onCreateList,
}) => {
    const translate = useTranslations();
    const { loginUrl } = useSettings();
    const { isLoggedIn, isAuthenticating } = useAuth();

    return (
        <div className={styles.wrapper}>
            <Text
                textStyle="Heading.XL"
                tagName="h1"
                className={styles.marginBottom}
            >
                {translate('LISTOVERVIEW_NAVIGATION_LISTS')}
            </Text>
            <Text
                textStyle="Body.M"
                tagName="p"
                className={styles.marginBottom}
            >
                {translate('LISTOVERVIEW_LISTS_CONTENT')}
            </Text>
            {!isLoggedIn && !isAuthenticating && (
                <Text
                    textStyle="Body.M"
                    tagName="p"
                    className={styles.marginBottom}
                >
                    {translate('LISTOVERVIEW_LISTS_LOGIN_CONTENT', {
                        phoneNumber: (
                            <Hyperlink
                                url={`tel:${translate('LISTOVERVIEW_LISTS_PHONENUMBER')}`}
                                text={translate(
                                    'LISTOVERVIEW_LISTS_PHONENUMBER'
                                )}
                            />
                        ),
                    })}
                </Text>
            )}
            <div className={styles.buttonGroup}>
                <Button
                    loading={loading}
                    type="primary"
                    data-testid="create-new-list"
                    text={translate('CREATEMODAL_LIST_FOOTER_BUTTON')}
                    disabled={disabled}
                    onClick={onCreateList}
                    size="small"
                />
                {!isLoggedIn && (
                    <Button
                        loading={isAuthenticating}
                        type="secondary"
                        text={translate('LISTOVERVIEW_LISTS_LOGIN_BUTTON')}
                        onClick={() => setLocationHref(loginUrl)}
                        size="small"
                    />
                )}
            </div>
        </div>
    );
};

export default CreateListBlock;
